import Container from "../../common/Container";
import { BrandLogo } from "../../common/BrandLogo";
import { SvgIcon } from "../../common/SvgIcon";
import { useSectionLink } from "../../common/utils/navigation";
import { SECTIONS } from "../../content/nav";
import { BADGES, SITE, SOCIAL, STORE } from "../../content/site";
import {
  Blurb,
  Bottom,
  BrandBlock,
  BrandRow,
  ColumnTitle,
  Copyright,
  FooterAnchor,
  FooterButton,
  FooterLink,
  FooterSection,
  Grid,
  LinkList,
  Social,
  StoreBadges,
} from "./styles";

const Footer = () => {
  const goToSection = useSectionLink();
  const year = new Date().getFullYear();

  return (
    <FooterSection>
      <Container>
        <Grid>
          <BrandBlock>
            <BrandRow to="/" aria-label="The Ghost — home">
              <BrandLogo height={22} alt="" />
            </BrandRow>
            <Blurb>
              {SITE.tagline} by {SITE.studio}. Free on iOS and Android.
            </Blurb>
            <Social>
              <a
                href={SOCIAL.discord}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="The Ghost on Discord"
              >
                <SvgIcon src="discord.webp" width="18px" height="18px" />
              </a>
              <a
                href={SOCIAL.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${SITE.studio} on Facebook`}
              >
                <SvgIcon src="facebook.webp" width="18px" height="18px" />
              </a>
            </Social>
          </BrandBlock>

          <nav aria-labelledby="footer-game">
            <ColumnTitle id="footer-game">Game</ColumnTitle>
            <LinkList>
              {SECTIONS.map((section) => (
                <li key={section.id}>
                  <FooterButton onClick={goToSection(section.id)}>
                    {section.label}
                  </FooterButton>
                </li>
              ))}
            </LinkList>
          </nav>

          <nav aria-labelledby="footer-community">
            <ColumnTitle id="footer-community">Community</ColumnTitle>
            <LinkList>
              <li>
                <FooterAnchor
                  href={SOCIAL.discord}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Discord
                </FooterAnchor>
              </li>
              <li>
                <FooterAnchor
                  href={SOCIAL.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </FooterAnchor>
              </li>
              <li>
                <FooterAnchor href={`mailto:${SITE.email}`}>
                  Contact us
                </FooterAnchor>
              </li>
            </LinkList>
          </nav>

          <nav aria-labelledby="footer-legal">
            <ColumnTitle id="footer-legal">Legal</ColumnTitle>
            <LinkList>
              {/* Canonical paths, matching what's live and what the store
                  listings link to. /terms and /privacy still redirect here. */}
              <li>
                <FooterLink to="/terms_of_service">Terms of Service</FooterLink>
              </li>
              <li>
                <FooterLink to="/privacy_policy">Privacy Policy</FooterLink>
              </li>
              <li>
                <FooterLink to="/rules_of_conduct">Rules of Conduct</FooterLink>
              </li>
              <li>
                <FooterLink to="/about">About us</FooterLink>
              </li>
              <li>
                <FooterAnchor
                  href={`mailto:${SITE.email}?subject=Copyright%20notice`}
                >
                  Copyright notice
                </FooterAnchor>
              </li>
            </LinkList>
          </nav>
        </Grid>

        <Bottom>
          <Copyright>
            © {year} {SITE.studio}. All rights reserved.
          </Copyright>

          <StoreBadges>
            <a
              href={STORE.googlePlay}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get The Ghost on Google Play"
            >
              <SvgIcon src={BADGES.googlePlay} width="auto" height="40px" />
            </a>
            <a
              href={STORE.appStore}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download The Ghost on the App Store"
            >
              <SvgIcon src={BADGES.appStore} width="auto" height="40px" />
            </a>
          </StoreBadges>
        </Bottom>
      </Container>
    </FooterSection>
  );
};

export default Footer;
